// extracted by mini-css-extract-plugin
export var addressFields = "_oe-0";
export var animationContainer = "_oe-1";
export var footer = "_oe-2";
export var lineItems = "_oe-3";
export var modalContent = "_oe-4";
export var orderName = "_oe-5";
export var strong = "_oe-6";
export var warning = "_oe-7";